import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"

//components
import Field from "../../Common/Field/Field"
import options from "../../../services/common/options"

export default class FullPackage extends Component {
  render() {
    const { fullPackageData, fabricInfo, disabled } = this.props
    return (
      <form name="fullPackageForm">
        <div className="col-md-12 fullPackCon p-0">
          <label className="font-weight-bold">Full Package</label>
          {!disabled && (
            <a
              style={{ display: "block" }}
              className="btn-floating btn-small waves-effect waves-light green pull-right"
              onClick={e => this.props.addFullPackageCount()}
            >
              <i className="material-icons">add</i>
            </a>
          )}
        </div>
        <div>
          {fullPackageData.map((data, index) => {
            return (
              <div className="col-md-12 nopadding" key={index} id={`fullPack${index}`}>
                <div className="card">
                  <div class="col-md-12 nopadding">
                    <div class="col-md-6">
                      <h6 className="p-3">{index + 1}</h6>
                    </div>
                    {!disabled && (
                      <div class="col-md-6">
                        <a
                          style={{ display: "block" }}
                          class="btn-floating btn-small waves-effect waves-light red pull-right my-3 mr-3"
                          id="del-sample-size-btn pull-rog pull-right"
                          onClick={() => this.props.removeFullPackage(index)}
                        >
                          <i class="material-icons">clear</i>
                        </a>
                      </div>
                    )}
                  </div>

                  <div id="fullpackage" className="col-md-12">
                    <table class="table sizing-for-table">
                      <thead>
                        <tr class="style-table-border">
                          <th width="9%">Purpose</th>
                          <th width="12%">Date</th>
                          <th width="15%">Supplier Name</th>
                          <th width="8%">Supplier Ref</th>
                          <th width="6%">
                            LT
                            <br />
                            (days)
                          </th>
                          <th width="8%">Width</th>
                          <th width="6%">$/₹</th>
                          <th width="11%">Price</th>
                          <th width="7%">Units</th>
                          <th width="5%">GST%</th>
                          <th width="5%">Trans</th>
                          <th width="8%">Total cost</th>
                          <th width="5%">Default</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="style-table-border">
                          <td>
                            <select
                              className="select-currency"
                              name="purpose"
                              onChange={e =>
                                this.props.updateValue(
                                  e.target.name,
                                  e.target.value,
                                  index
                                )
                              }
                              disabled={disabled}
                              value={data.purpose}
                            >
                              <option value="">select</option>
                              {fabricInfo &&
                                fabricInfo.PURPOSE &&
                                fabricInfo.PURPOSE.map(data => {
                                  return (
                                    <option value={data.value}>
                                      {data.label}
                                    </option>
                                  )
                                })}
                            </select>
                          </td>
                          <td>
                            <Field
                              isFormGroup={false}
                              inputType="date"
                              inputName="date"
                              value={data.date ? data.date : ""}
                              index={index}
                              onChange={this.props.updateValue}
                              disabled={disabled}
                            />
                          </td>
                          <td>
                            <select
                              className="form-control select-currency"
                              name="supplierName"
                              onChange={e =>
                                this.props.updateValue(
                                  e.target.name,
                                  e.target.value,
                                  index
                                )
                              }
                              disabled={disabled}
                              value={data.supplierName}
                            >
                              <option value="">Select</option>
                              {fabricInfo &&
                                fabricInfo.SUPPLIERNAME &&
                                fabricInfo.SUPPLIERNAME.map((data, index) => (
                                  <option value={data.value}>
                                    {data.label}
                                  </option>
                                ))}
                            </select>
                          </td>
                          <td>
                            <input
                              type="text"
                              class="form-control"
                              name="supplierRef"
                              onChange={e =>
                                this.props.updateValue(
                                  e.target.name,
                                  e.target.value,
                                  index
                                )
                              }
                              disabled={disabled}
                              value={data.supplierRef}
                            />
                          </td>
                          <td>
                            <Field
                              isFormGroup={false}
                              inputType="number"
                              max={3}
                              value={data.leadTime}
                              inputName="leadTime"
                              index={index}
                              onChange={this.props.updateValue}
                              disabled={disabled}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              min="0"
                              class="form-control"
                              name="width"
                              onChange={e =>
                                this.props.updateValue(
                                  e.target.name,
                                  e.target.value,
                                  index
                                )
                              }
                              disabled={disabled}
                              value={data.width}
                            />
                          </td>
                          <td>
                            <select
                              className="select-currency"
                              name="currency"
                              onChange={e =>
                                this.props.updateValue(
                                  e.target.name,
                                  e.target.value,
                                  index
                                )
                              }
                              disabled={disabled}
                              value={data.currency}
                            >
                              <option value="">---</option>
                              {options.currency.map((value, index) => (
                                <option value={value.value} key={index}>
                                  {value.label}
                                </option>
                              ))}
                            </select>
                          </td>
                          <td>
                            <input
                              type="number"
                              min="0"
                              class="form-control"
                              name="price"
                              value={data.price}
                              onChange={e =>
                                this.props.updateValue(
                                  e.target.name,
                                  e.target.value,
                                  index
                                )
                              }
                              disabled={disabled}
                            />
                          </td>
                          <td>
                            <select
                              className="select-currency"
                              name="MY"
                              value={data.MY}
                              onChange={e =>
                                this.props.updateValue(
                                  e.target.name,
                                  e.target.value,
                                  index
                                )
                              }
                              disabled={disabled}
                            >
                              {this.props.moduleName.toLowerCase() ===
                                "trims" ? (
                                  <Fragment>
                                    <option value="">---</option>
                                    <option value="gross">GROSS</option>
                                    <option value="meter">MTRS</option>
                                    <option value="yard">YD</option>
                                    <option value="pcs">PCS</option>
                                    <option value="sets">SETS</option>
                                  </Fragment>
                                ) : this.props.moduleName.toLowerCase() ===
                                  "fabric" ? (
                                    <Fragment>
                                      <option value="">---</option>
                                      <option value="meter">MTRS</option>
                                      <option value="yard">YD</option>
                                    </Fragment>
                                  ) : null}
                            </select>
                          </td>
                          <td>
                            <input
                              type="number"
                              min="0"
                              class="form-control"
                              name="GST"
                              value={data.currency !== "dollar" ? data.GST : ""}
                              onChange={e =>
                                this.props.updateValue(
                                  e.target.name,
                                  e.target.value,
                                  index
                                )
                              }
                              disabled={disabled || data.currency == "dollar"}
                            // value={data.GST}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              min="0"
                              class="form-control"
                              name="transport"
                              value={
                                data.currency !== "dollar" ? data.transport : ""
                              }
                              onChange={e =>
                                this.props.updateValue(
                                  e.target.name,
                                  e.target.value,
                                  index
                                )
                              }
                              disabled={disabled || data.currency == "dollar"}
                            // value={data.transport}
                            />
                          </td>
                          <td>
                            {fullPackageData[index].totalCost
                              ? fullPackageData[index].totalCost
                              : ""}
                          </td>
                          <td>
                            <Field
                              isFormGroup={false}
                              inputType="radio"
                              inputName={`default`}
                              value={"fullpackage" + index}
                              checked={data.default}
                              index={index}
                              onChange={(name, value) =>
                                this.props.updateValueForDefault(
                                  name,
                                  value,
                                  index,
                                  "fullpackage",
                                  fullPackageData
                                )
                              }
                              disabled={disabled}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  {data.currency == "dollar" ? (
                    <div className="col-md-12">
                      <div className="col-md-6">
                        <table class="table">
                          <tbody>
                            <tr>
                              <td className="border-0">Price $ </td>
                              <td className="border-0" />
                              <td className="border-0">
                                <Field
                                  isFormGroup={false}
                                  inputType={"number"}
                                  inputName={"price"}
                                  value={data.price}
                                  index={index}
                                  onChange={this.props.updateValue}
                                  disabled={disabled}
                                />
                              </td>
                              <td className="border-0">
                                <select
                                  className="select-currency"
                                  name="MY"
                                  value={data.MY}
                                  onChange={e =>
                                    this.props.updateValue(
                                      e.target.name,
                                      e.target.value,
                                      index
                                    )
                                  }
                                  disabled={disabled}
                                >
                                  {this.props.moduleName.toLowerCase() ===
                                    "trims" ? (
                                      <Fragment>
                                        <option value="">---</option>
                                        <option value="gross">GROSS</option>
                                        <option value="meter">MTRS</option>
                                        <option value="yard">YD</option>
                                        <option value="pcs">PCS</option>
                                        <option value="sets">SETS</option>
                                      </Fragment>
                                    ) : this.props.moduleName.toLowerCase() ===
                                      "fabric" ? (
                                        <Fragment>
                                          <option value="">---</option>
                                          <option value="meter">MTRS</option>
                                          <option value="yard">YD</option>
                                        </Fragment>
                                      ) : null}
                                </select>
                              </td>
                            </tr>
                            <tr className="border-0">
                              <td className="border-0" />
                              <td className="border-0" />
                              <td className="border-0">
                                {data.currencyData.priceMTS}
                              </td>
                              <td className="border-0">
                                {data.MY === "gross" ? "PER PC" : data.MY}
                              </td>
                            </tr>
                            <tr>
                              <td className="border-0">Convertion to INR</td>
                              <td className="border-0" />
                              <td className="border-0">
                                {data.currencyData.conversionToINR}
                              </td>
                              <td className="border-0">
                                <span style={{ fontSize: "1.05rem" }}>$</span>
                                <input
                                  type="number"
                                  style={{ width: "25%" }}
                                  value={this.props.USDtoINR}
                                  onChange={e =>
                                    this.props.updateINRCurrency(e)
                                  }
                                />
                                <span style={{ fontSize: "1.2rem" }}>₹</span>
                              </td>
                            </tr>
                            <tr className="border-0">
                              <td className="border-0">Shipment term</td>
                              <td className="border-0" />
                              <td className="border-0">
                                <select
                                  className="form-control select-currency"
                                  name="shipmentTerm"
                                  value={data.currencyData.shipmentTerm}
                                  disabled={disabled}
                                  onChange={e =>
                                    this.props._inputForCurrency(
                                      e.target.name,
                                      e.target.value,
                                      index
                                    )
                                  }
                                >
                                  <option value="">Select</option>
                                  {fabricInfo.SHIPMENTTERM.map(dat => {
                                    return (
                                      <option value={dat.label}>
                                        {dat.label}
                                      </option>
                                    )
                                  })}
                                </select>
                              </td>
                              <td className="border-0" />
                            </tr>
                            <tr className="border-0">
                              <td className="border-0">Ship Mode</td>
                              <td className="border-0" />

                              <td className="border-0">
                                <select
                                  className="form-control select-currency"
                                  name="shipmentMode"
                                  value={data.currencyData.shipmentMode}
                                  disabled={disabled}
                                  onChange={e =>
                                    this.props._inputForCurrency(
                                      e.target.name,
                                      e.target.value,
                                      index
                                    )
                                  }
                                >
                                  <option value="">Select</option>
                                  {fabricInfo.SHIPMENTMODE.map(dat => {
                                    return (
                                      <option value={dat.label}>
                                        {dat.label}
                                      </option>
                                    )
                                  })}
                                </select>
                              </td>
                              <td className="border-0" />
                            </tr>
                            <tr className="border-0">
                              <td className="border-0">Port of Pick up</td>
                              <td className="border-0" />

                              <td className="border-0">
                                <select
                                  className="form-control select-currency"
                                  name="portOfPickup"
                                  value={data.currencyData.portOfPickup}
                                  disabled={disabled}
                                  onChange={e =>
                                    this.props._inputForCurrency(
                                      e.target.name,
                                      e.target.value,
                                      index
                                    )
                                  }
                                >
                                  <option value="">Select</option>
                                  {fabricInfo.PORTOFPICKUP.map(dat => {
                                    return (
                                      <option value={dat.name}>
                                        {dat.name}
                                      </option>
                                    )
                                  })}
                                </select>
                              </td>
                              <td className="border-0" />
                            </tr>
                            <tr className="border-0">
                              <td className="border-0">Freight costs ₹</td>
                              <td className="border-0" />

                              <td className="border-0">
                                <Field
                                  isFormGroup={false}
                                  inputType={"number"}
                                  inputName={"freightCosts"}
                                  value={data.currencyData.freightCosts}
                                  index={index}
                                  onChange={this.props._inputForCurrency}
                                  disabled={disabled}
                                />
                              </td>
                              <td className="border-0" />
                            </tr>
                            <tr className="border-0">
                              <td className="border-0">Clearance ₹</td>
                              <td className="border-0" />

                              <td className="border-0">
                                <Field
                                  isFormGroup={false}
                                  inputType={"number"}
                                  inputName={"clearance"}
                                  value={data.currencyData.clearance}
                                  index={index}
                                  onChange={this.props._inputForCurrency}
                                  disabled={disabled}
                                />
                              </td>
                              <td className="border-0" />
                            </tr>
                            <tr className="border-0">
                              <td className="border-0">Duty %</td>
                              <td className="border-0" />

                              <td className="border-0">
                                <Field
                                  isFormGroup={false}
                                  inputType={"number"}
                                  inputName={"duty"}
                                  value={data.currencyData.duty}
                                  index={index}
                                  onChange={this.props._inputForCurrency}
                                  disabled={disabled}
                                />
                              </td>
                              <td className="border-0" />
                            </tr>
                            <tr className="border-0">
                              <td className="border-0">
                                <label className="pt-2">
                                  Total {this.props.moduleName} Cost
                                </label>
                              </td>
                              <td className="border-0" />
                              <td className="thicker border-0">
                                ₹ {data.totalCost}
                              </td>
                              <td className="border-0" />
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="col-md-6">
                        <div className="col-md-8">
                          {this.props.moduleName.toLowerCase() ===
                            "trims" ? null : this.props.moduleName.toLowerCase() ===
                              "fabric" ? (
                                <table class="table">
                                  <tbody>
                                    <tr className="border-0">
                                      <td className="border-0">
                                        Total Order quantity
                                  </td>
                                      <td className="border-0">
                                        <Field
                                          isFormGroup={false}
                                          inputType="number"
                                          inputName="totalOrderQuantity"
                                          value={
                                            data.currencyData.totalOrderQuantity
                                              ? data.currencyData.totalOrderQuantity
                                              : ""
                                          }
                                          index={index}
                                          onChange={this.props._inputForCurrency}
                                          disabled={
                                            data.currencyData.portOfPickup === null
                                              ? true
                                              : disabled
                                          }
                                        />
                                      </td>
                                    </tr>
                                    <tr className="border-0">
                                      <td className="border-0">Width</td>
                                      <td className="border-0">
                                        <Field
                                          isFormGroup={false}
                                          inputType="number"
                                          inputName="width"
                                          value={
                                            data.currencyData.width
                                              ? data.currencyData.width
                                              : ""
                                          }
                                          index={index}
                                          onChange={this.props._inputForCurrency}
                                          disabled={
                                            data.currencyData.portOfPickup === null
                                              ? true
                                              : disabled
                                          }
                                        />
                                      </td>
                                    </tr>
                                    <tr className="border-0">
                                      <td className="border-0">GSM</td>
                                      <td className="border-0">
                                        <Field
                                          isFormGroup={false}
                                          inputType="number"
                                          inputName="gsm"
                                          value={
                                            data.currencyData.gsm
                                              ? data.currencyData.gsm
                                              : ""
                                          }
                                          index={index}
                                          onChange={this.props._inputForCurrency}
                                          disabled={
                                            data.currencyData.portOfPickup === null
                                              ? true
                                              : disabled
                                          }
                                        />
                                      </td>
                                    </tr>
                                    <tr className="border-0">
                                      <td className="border-0">
                                        Weight of Fabric Per Mtr
                                  </td>
                                      <td className="border-0">
                                        {data.currencyData.weightOfFabricPerMtr
                                          ? data.currencyData.weightOfFabricPerMtr
                                          : ""}
                                      </td>
                                    </tr>
                                    <tr className="border-0">
                                      <td className="border-0">
                                        Weight for Full Order
                                  </td>
                                      <td className="border-0">
                                        {data.currencyData.weightForFullOrder
                                          ? data.currencyData.weightForFullOrder
                                          : ""}
                                      </td>
                                    </tr>
                                    <tr className="border-0">
                                      <td className="border-0">
                                        Freight Rate per kg
                                  </td>
                                      <td className="border-0">
                                        {data.currencyData.freightRatePerKg
                                          ? data.currencyData.freightRatePerKg
                                          : ""}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              ) : null}
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <div className="col-md-12">
                    <div className="col-md-2">
                      <Field
                        isFormGroup={true}
                        inputType={"text"}
                        inputName={"moq"}
                        value={data.moq}
                        index={index}
                        label={"Moq "}
                        onChange={this.props.updateMoqSupplierSectionHandler}
                        disabled={disabled}
                      // disabled={true}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <Field
                      isFormGroup={true}
                      inputType={"textarea"}
                      inputName={"specialComments"}
                      value={data.specialComments}
                      index={index}
                      label={"Special Comments"}
                      onChange={this.props.updateValue}
                      disabled={disabled}
                    />
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </form>
    )
  }
}

FullPackage.propTypes = {}

FullPackage.defaultProps = {}


// WEBPACK FOOTER //
// ./src/components/SupplierSection/SupplierMain/FullPackage.js